// LOAD ALL THE READ ONLY DATA
import { makeSetReducer } from "./utils";

export const subestadosIncidenciaFullfilledReducer = makeSetReducer(['subestados_incidencia/fullfilled']);
